import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

// Import Reducers
import global from './containers/Full/reducer';
import dashboard from './views/Dashboard/reducer';
import login from './views/Pages/Login/reducer';
import confirmationRegist from './views/Pages/ActiveAcc/reducer';
import resendConfirmAcc from './views/Pages/ResendConfirmAcc/reducer';
import forgotPassword from './views/Pages/ResendResetPwCode/reducer';
import resetPassword from './views/Pages/ResetPassword/reducer';
import loginMfa from './views/Pages/LoginMfa/reducer';
import changePass from './views/Pages/ChangePassword/reducer';
import twoFASetting from './views/Pages/TwoFASetting/reducer'
import register from './views/Pages/Register/reducer';
import profile from './views/Pages/MyAccount/reducer';
import client  from './views/client/reducer'
import header from './components/Header/reducer'
import sidebar from './components/Sidebar/reducer'
import adminUserList  from './views/Admin/AdminUser/reducer'
import activities  from './views/Admin/ActivityLog/reducer'

// components 
import stats from './components/Stats/reducer'
import chart from './components/Chart/reducer'
import chart2 from './components/Chart2/reducer'

import role  from './views/Role/reducer'
import roleEdit  from './views/Role/reducer'
import nhapkho  from './views/NhapKho/reducer'
import nhapkhoEdit  from './views/NhapKho/reducer'
import nhapkhoEditCt  from './views/NhapKho/reducer'
import lsnhapkho  from './views/LsNhapKho/reducer'
import nganhHang  from './views/NganhHang/reducer'
import nganhHangEdit  from './views/NganhHang/reducer'
import nhomKhachHang  from './views/NhomKhachHang/reducer'
import nhomKhachHangEdit  from './views/NhomKhachHang/reducer'
import nhaCungCap  from './views/NhaCC/reducer'
import nhaCungCapEdit  from './views/NhaCC/reducer'
import kho  from './views/Kho/reducer'
import khoEdit  from './views/Kho/reducer'
import products  from './views/Products/reducer'
import productsEdit  from './views/Products/reducer'
import khachHangNhom  from './views/KhachHangNhom/reducer'
import nguoiDungKho  from './views/NguoiDungKho/reducer'
import nguoiDungRole  from './views/NguoiDungRole/reducer'
import permissionRole  from './views/PermissionRole/reducer'
import chuongTrinh  from './views/ChuongTrinh/reducer'
import chuongTrinhEdit  from './views/ChuongTrinh/reducer'
import chuongTrinhProduct  from './views/ChuongTrinh/reducer'
import khachhang  from './views/KhachHang/reducer'
import khachhangEdit  from './views/KhachHang/reducer'
import orders  from './views/Orders/reducer'
import order  from './views/Order/reducer'
import orderEdit  from './views/Order/reducer'
import khachhangUser  from './views/KhachHang/reducer'
import tonKho  from './views/TonKho/reducer'
import tonKhoEdit  from './views/TonKho/reducer'
import guestReport  from './views/Reports/GuestReport/reducer'
import importReport  from './views/Reports/ImportReport/reducer'
import orderReport  from './views/Reports/OrderReport/reducer'
import salaryReport  from './views/Reports/SalaryReport/reducer'
import salaryReportDetail  from './views/Reports/SalaryReportDetail/reducer'
import saleDetailReport  from './views/Reports/SaleDetailReport/reducer'
import saleTotalReport  from './views/Reports/SaleTotalReport/reducer'
import saleReport  from './views/Reports/SaleReport/reducer'
import giaoHangReport  from './views/Reports/GiaoHangReport/reducer'
import giaoHang  from './views/GiaoHang/reducer'
import giaoHangEdit  from './views/GiaoHang/reducer'
import congNo  from './views/CongNo/reducer'
import congNoKh  from './views/CongNoKhachHang/reducer'
import congNoKhCt  from './views/CongNoKhachHang/reducer'
import congNoHD  from './views/CongNo/reducer'
import contracts  from './views/Contracts/reducer'
import contractEdit  from './views/Contracts/reducer'
import traHang  from './views/TraHang/reducer'
import setting  from './views/Setting/reducer'
import bacLuongEdit  from './views/BacLuong/reducer'
import bacLuong  from './views/BacLuong/reducer'
import bacLuongUser  from './views/BacLuong/reducer'
import congNoNhanVien  from './views/CongNoNhanVien/reducer'
import lichSuThanhToan  from './views/LichSuThanhToan/reducer'
import lichSuThanhToanEdit  from './views/LichSuThanhToan/reducer'
import congNoNhanVienByKh  from './views/CongNoKhachHang/reducer'
import profitReport  from './views/Reports/ProfitReport/reducer'
import lichSuTraThuong  from './views/LichSuTraThuong/reducer'
import {
  CLIENT_UNSET,
} from './views/client/constants'

const AppReducer = combineReducers({
  global,
  form,
  stats,
  login,
  resendConfirmAcc,
  confirmationRegist,
  forgotPassword,
  resetPassword,
  register,
  client,
  header,
  dashboard,
  profile,
  changePass,
  twoFASetting,
  loginMfa,
  adminUserList,
  activities,
  sidebar,
  role,
  roleEdit,
  nhapkho,
  nhapkhoEdit,
  nhapkhoEditCt,
  lsnhapkho,
  nganhHang,
  nganhHangEdit,
  nhomKhachHang,
  nhomKhachHangEdit,
  nhaCungCap,
  nhaCungCapEdit,
  kho,
  khoEdit,
  products,
  productsEdit,
  khachHangNhom,
  nguoiDungKho,
  chuongTrinh,
  chuongTrinhEdit,
  chuongTrinhProduct,
  nguoiDungRole,
  khachhang,
  khachhangEdit,
  orders,
  order,
  orderEdit,
  khachhangUser,
  tonKho,
  tonKhoEdit,
  guestReport,
  importReport,
  orderReport,
  saleDetailReport,
  saleTotalReport,
  saleReport,
  giaoHang,
  giaoHangEdit,
  congNo,
  congNoKh,
  congNoKhCt,
  congNoHD,
  permissionRole,
  contracts,
  contractEdit,
  traHang,
  chart,
  chart2,
  setting,
  giaoHangReport,
  bacLuong,
  bacLuongEdit,
  bacLuongUser,
  salaryReport,
  salaryReportDetail,
  congNoNhanVien,
  lichSuThanhToan,
  lichSuThanhToanEdit,
  congNoNhanVienByKh,
  profitReport,
  lichSuTraThuong,
})

const IndexReducer = ( state, action ) => {
  if ( action.type === CLIENT_UNSET ) {
    // clear safe data
    state = undefined;
  }

  return AppReducer(state, action)
}

export default IndexReducer



// WEBPACK FOOTER //
// ./src/index-reducer.js